<script setup lang="ts">
import UiChip from '../ui/UiChip.vue'

interface Props {
    hiredOnShopexperts: boolean;
}

const props = defineProps<Props>();
</script>
<template>
    <UiChip v-if="props.hiredOnShopexperts" text="Hired on shopexperts" size="xs" variant="success" rounded="full"
        icon="shopexperts-star" />
</template>